import { defineMessages } from 'react-intl';

export const messages: {
	clearIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	popupPlaceholderText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	clearIconLabel: {
		id: 'company-hub.company-hub-common.link-picker.clear-icon-label',
		defaultMessage: 'Clear link selection',
		description: 'Label on hover for clear icon after link selection',
	},
	popupPlaceholderText: {
		id: 'company-hub.company-hub-common.link-picker.popup-placeholder-text',
		defaultMessage: 'Add any link',
		description: 'Visible placeholder text to appear when no link selected in Popup button',
	},
});
